import { useQuery } from '@tanstack/react-query'

import { getEvidences } from '@src/api'
import { DefaultApiGetEvidencesRequest } from '@src/api/generated/user-api'
import { REACT_QUERY_CACHE_KEYS } from '@src/consts'
import { useAxios } from '@src/hooks'

export const useFetchEvidences = (params: DefaultApiGetEvidencesRequest) => {
  const { axiosInstance } = useAxios()

  return useQuery({
    enabled: !!params.organizationId && !!params.paymentReferenceId,
    queryFn: () => getEvidences(axiosInstance, params),
    queryKey: [
      REACT_QUERY_CACHE_KEYS.GET_EVIDENCES,
      params.organizationId,
      params.paymentReferenceId,
    ],
  })
}
